module.exports = __webpack_public_path__ + "img/confirm-btn_no.accd1df6.png";